import React from 'react';

export default function FoxTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="23.68,36.71 13.1,36.71 11.89,26.33 22.46,26.33" fill="#B47A4D" />
      <polygon points="13.1,36.71 23.68,36.71 22.21,38.0 11.64,38.0" fill="#6D492D" opacity="0.95" />
      <polygon points="13.1,36.71 11.64,38.0 10.42,27.63 11.89,26.33" fill="#6D492D" opacity="0.95" />
      <polygon points="30.33,15.83 16.23,15.83 14.61,2.0 28.71,2.0" fill="#B47A4D" />
      <polygon points="16.23,15.83 30.33,15.83 23.49,21.86 9.4,21.86" fill="#6D492D" opacity="0.95" />
      <polygon points="16.23,15.83 9.4,21.86 7.78,8.02 14.61,2.0" fill="#6D492D" opacity="0.95" />
      <polygon points="32.22,29.18 21.65,29.18 20.44,18.81 31.01,18.81" fill="#B47A4D" />
      <polygon points="21.65,29.18 32.22,29.18 28.8,32.19 18.23,32.19" fill="#6D492D" opacity="0.95" />
      <polygon points="21.65,29.18 18.23,32.19 17.02,21.82 20.44,18.81" fill="#6D492D" opacity="0.95" />
      <polygon points="32.22,29.18 21.65,29.18 20.44,18.81 31.01,18.81" fill="#B47A4D" />
      <polygon points="21.65,29.18 32.22,29.18 28.8,32.19 18.23,32.19" fill="#6D492D" opacity="0.95" />
      <polygon points="21.65,29.18 18.23,32.19 17.02,21.82 20.44,18.81" fill="#6D492D" opacity="0.95" />
    </svg>
  );
}
